export var convertToCreateDto = function (data) {
    var dtoData = {
        name: data.name,
    };
    return dtoData;
};
